import React, { useRef, useEffect, useState } from 'react';
import '../../Assets/CSS/About.css';
import { useLocation } from 'react-router-dom';

const About = () => {
    const [about, setAbout] = useState([]);
    const location = useLocation();
    const aboutRef = useRef(null);


    useEffect(() => {
        if (location.hash === "#about-section" && aboutRef.current) {
            setTimeout(() => {
                const yOffset = -80;
                const y = aboutRef.current.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }, 200);
        }
        fetchAboutUS();
    }, [location]);

    const fetchAboutUS = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/about-platform`);
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setAbout(data);
            } else {
                console.error('Error fetching about us data');
            }

        }
        catch (error) {
            console.error('Error fetching about us data:', error);
        }

    }

    return (
        <section id="about-section" ref={aboutRef}>
            <div className='  mt-5' >
                <div className='About'>
                    <div className='container-fluid px-3 py-lg-5 py-3'>
                        <div className='row px-3 '>
                            {/* Text Section */}
                            <div className='col-md-12 col-lg-6 col-12 about-section text-left'>
                                <h1 className='text-dark fw-bold heading' style={{marginBottom:'35px'}}>
                                    About Us
                                </h1>
                                <p className='fs-6 about-desc text-dark'>
                                    {about.aboutUsDescription}

                                </p>
                            </div>
                            {/* Image Section */}
                            <div className='col-md-12 col-lg-6 col-12 d-flex justify-content-center'>
                                <div className=' pt-4 image-container'>
                                    <img src={about.aboutUsImageUrl} alt='about-image' className='abtimg img-fluid' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default About;
